var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCuratedFindings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "#9A9A9A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    clipRule: "evenodd",
    d: "M14.4999 11.1875C10.9583 11.1875 7.93367 13.3904 6.70825 16.5C7.93367 19.6096 10.9583 21.8125 14.4999 21.8125C18.0416 21.8125 21.0662 19.6096 22.2916 16.5C21.0662 13.3904 18.0416 11.1875 14.4999 11.1875ZM14.4999 20.0417C12.5449 20.0417 10.9583 18.455 10.9583 16.5C10.9583 14.545 12.5449 12.9583 14.4999 12.9583C16.4549 12.9583 18.0416 14.545 18.0416 16.5C18.0416 18.455 16.4549 20.0417 14.4999 20.0417ZM12.3749 16.5C12.3749 15.3242 13.3241 14.375 14.4999 14.375C15.6758 14.375 16.6249 15.3242 16.6249 16.5C16.6249 17.6758 15.6758 18.625 14.4999 18.625C13.3241 18.625 12.3749 17.6758 12.3749 16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    clipRule: "evenodd",
    d: "M14.5001 7.75002H24.1667C25.4959 7.75002 26.5834 8.91252 26.5834 10.3334V23.25C26.5834 24.6709 25.4959 25.8334 24.1667 25.8334H4.83341C3.50425 25.8334 2.41675 24.6709 2.41675 23.25L2.42883 7.75002C2.42883 6.32919 3.50425 5.16669 4.83341 5.16669H11.0805C11.7209 5.16669 12.3372 5.43794 12.7963 5.92877L14.5001 7.75002ZM6.04175 23.25H22.9584C23.623 23.25 24.1667 22.6688 24.1667 21.9584V11.625C24.1667 10.9146 23.623 10.3334 22.9584 10.3334H6.04175C5.37716 10.3334 4.83341 10.9146 4.83341 11.625V21.9584C4.83341 22.6688 5.37716 23.25 6.04175 23.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedFindings);
export default __webpack_public_path__ + "static/media/curatedFindings.7377f99a.svg";
export { ForwardRef as ReactComponent };